import React, { useState, useEffect } from "react";
import { X, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheGlowStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  return <section data-section-id="21317" id="the-gold-standard-of-arrival" className="dark bg-background text-foreground relative min-h-screen w-full overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/60 z-10" />
        <div className="h-full w-full bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598014/img/hero_luxury_steering_wheel.png)] bg-cover bg-center bg-no-repeat grayscale-[0.2]" />
      </div>

      {}
      <div className="relative z-20 flex min-h-screen flex-col items-center justify-center px-4 text-center">
        <div ref={ref} className={`max-w-5xl transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-[80px] leading-[1.1] text-white mb-6 tracking-tight [text-shadow:0_4px_20px_rgba(184,134,11,0.4)]">
            Your Flight Lands. Your Driver Is Already There.
          </h1>
          <p className="font-sans text-lg md:text-xl text-pearl/90 mb-10 max-w-2xl mx-auto font-normal leading-relaxed tracking-wide">
            Private airport transfers and executive ground transportation across the San Francisco Bay Area. SFO · SJC · OAK — available 24/7.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <Button asChild className="h-14 rounded-sm px-10 text-base font-medium bg-primary text-primary-foreground hover:bg-primary/90 border-none shadow-[0px_10px_30px_0px_rgba(184,134,11,0.3)] transition-transform hover:scale-105">
              <Link to="#book-now">Book Your Ride</Link>
            </Button>
            <Button asChild variant="outline" className="h-14 rounded-sm px-10 text-base font-medium bg-transparent border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-transform hover:scale-105">
              <Link to="#fleet">View Our Fleet.</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      {showModal && <div className="fixed bottom-6 left-6 z-50 w-full max-w-[90vw] sm:max-w-md animate-in slide-in-from-bottom-10 fade-in duration-700">
          <div className="relative overflow-hidden rounded-sm bg-card border border-white/10 shadow-[0px_20px_40px_rgba(0,0,0,0.6)]">
            {}
            <Button variant="ghost" size="icon" onClick={() => setShowModal(false)} className="absolute top-3 right-3 z-20 h-8 w-8 rounded-full bg-black/40 text-pearl/70 hover:bg-black/60 hover:text-white shadow-sm" aria-label="Close offer">
              <X className="h-4 w-4" />
            </Button>

            {}
            <div className="h-48 w-full overflow-hidden">
              <img src="https://just-cheetah.10web.cloud/wp-content/uploads/2026/04/Used-2026-Cadillac-Escalade-Platinum-Sport-1767151418.jpg" alt="Executive Interior" className="h-full w-full object-cover transition-transform duration-700 hover:scale-110" />
            </div>

            {}
            <div className="p-6">
              <h3 className="font-serif text-2xl text-white mb-2 tracking-tight">
                Corporate Travel Excellence
              </h3>
              <p className="font-sans text-pearl/80 mb-3 leading-relaxed">
                Open a corporate account today and enjoy 15% off your first month of executive travel.
              </p>
              <p className="font-sans text-sm text-pearl/50 mb-4">
                Seamless billing, priority dispatch, and dedicated account management for your team.
              </p>

              <div className="flex flex-col gap-3">
                <Link to="#" className="inline-flex items-center text-sm font-medium text-primary hover:underline">
                  Read Terms and Conditions
                  <ArrowRight className="ml-1 h-3 w-3" />
                </Link>

                <Button asChild className="w-full rounded-sm bg-primary/10 text-primary border border-primary/30 hover:bg-primary hover:text-primary-foreground transition-all h-12 shadow-none">
                  <Link to="#">OPEN ACCOUNT NOW</Link>
                </Button>
              </div>
            </div>
          </div>
        </div>}
    </section>;
}